<form [formGroup]="vForm">
  <bb-input-email-ui
    label="E-mail address"
    formControlName="email"
    placeholder="Please enter a value..."
  >
  </bb-input-email-ui>
</form>
